"use strict";
app.controller('loginController',
    ["$scope", "$rootScope", "$location", "$http", "$routeParams", "authService", "ngAuthSettings", "signalrService",
    function ($scope, $rootScope, $location, $http, $routeParams, authService, ngAuthSettings, signalrService)
    {
    $scope.message = "";
    $scope.providerConfiguration = undefined;
    $scope.hasProviderConfiguration = false;
    $http.get("./api/Authenticate/ProviderConfiguration").success(function (result) {
        $scope.providerConfiguration = result;
        $scope.hasProviderConfiguration =
            $scope.providerConfiguration != undefined
            && $scope.providerConfiguration != null
            && $scope.providerConfiguration.configuration != undefined
            && $scope.providerConfiguration.configuration != null
            && $scope.providerConfiguration.configuration.authenticationTypes != undefined
            && $scope.providerConfiguration.configuration.authenticationTypes != null
            && $scope.providerConfiguration.configuration.authenticationTypes.length > 0;
    });
    $scope.authExternalProvider = function (provider) {
        var serviceBase = ngAuthSettings.apiServiceBaseUri;
        var redirectUri = serviceBase + "authcomplete.html";
        redirectUri = encodeURIComponent(redirectUri);
        var externalProviderUrl = serviceBase + "api/Account/ExternalLogin?provider=" + provider + "&response_type=token&client_id=" + ngAuthSettings.clientId + "&redirect_uri=" + redirectUri;
        window.$windowScope = $scope;
        var oauthWindow = window.open(externalProviderUrl, "Authenticate Account", "location=0,status=0,width=600,height=750");
    };
    $scope.login = function(provider) {
        $http.get("./api/Authenticate/SignIn?provider=" + provider).success(function(result) {
            window.location = result;
        });
    }
    $scope.authCompletedCB = function (fragment) {
        $scope.$apply(function () {
            var externalData = { provider: fragment.provider, externalAccessToken: fragment.external_access_token };
            authService.obtainAccessToken(externalData).then(function(response) {
                var data = {
                    afterSignInPath: authService.redirectUrl ? authService.redirectUrl : "/home"
                };
                authService.redirectUrl = undefined;
                $rootScope.$broadcast("userAuthenticated", data);
            }, function(err) {
                $scope.message = err.error_description;
            });
        });
    }

    // TODO: Remove this when done testing without internet
    //var redirectUrl = authService.redirectUrl ? authService.redirectUrl : "/home";
    //authService.obtainAccessTokenAutoSignInAsCody().then(() => $location.path(redirectUrl));
}]);